import './src/styles/global.css'

export const onClientEntry = () => {
  console.log("网站客户端加载完成")
}
